/**
 * Picks the first usable reference price from ordered candidates — mark price
 * outranks last-trade price, which outranks any stale fallback snapshot, since
 * a limit order should default to what it costs to trade now, not what it last
 * traded at. Missing/zero candidates mean "no data yet", not "price is zero".
 */
export function pickReferencePrice(...candidates: (string | undefined)[]): string | undefined {
  for (const candidate of candidates) {
    if (candidate && candidate !== '0') return candidate
  }
  return undefined
}
